<template>
  <div>
    <FlotoTechnicianPicker
      show-load-indicator
      :module-name="moduleName"
      @selected="triggerAction"
    >
      <template v-slot:trigger="{ toggle }">
        <div @click="toggle">
          <MIcon name="user-plus" class="mr-2 w-3" />
          <span class="mx-1 action-menu-text">
            {{ $t('assign') }}
          </span>
        </div>
      </template>
    </FlotoTechnicianPicker>
    <FlotoConfirmModal
      v-if="selectedUser"
      :open="showModal"
      prevent-auto-close-on-confirm
      :processing="processing"
      @hide="showModal = false"
      @confirm="handleConfirmAction"
    >
      <template v-slot:icon>
        <MIcon name="user-plus" class="w-full text-primary" size="2x" />
      </template>
      <template v-slot:message>
        {{
          $t('confirm_assign', {
            resource: $tc(moduleName, selectedItemIds.length),
            user: selectedUser.name,
          })
        }}
      </template>
    </FlotoConfirmModal>
  </div>
</template>

<script>
export default {
  name: 'Assign',
  props: {
    moduleName: { type: String, required: true },
    selectedItemIds: { type: Array, required: true },
    handleAssignRequests: { type: Function, default: undefined },
  },
  data() {
    return {
      showModal: false,
      processing: false,
      selectedUser: null,
    }
  },
  methods: {
    triggerAction(user) {
      this.selectedUser = user
      this.$emit('trigger')
      // show modal after dropdown is hide
      setTimeout(() => {
        this.showModal = true
      }, 400)
    },
    handleConfirmAction() {
      this.$emit('done')
      if (this.handleAssignRequests) {
        this.processing = true
        this.handleAssignRequests(this.selectedUser.id)
          .then(() => {
            this.showModal = false
            this.selectedUser = null
          })
          .finally(() => (this.processing = false))
      } else {
        this.showModal = false
      }
    },
  },
}
</script>
